export default __webpack_public_path__ + "locale.266b5009.csv";